const ConversationView2 = () =>
  import(
    /* webpackChunkName: "Conversations" */ 'src/components/Dashboard/Views/Conversations/ConversationView2.vue'
  );
const ConversationView = () =>
  import(
    /* webpackChunkName: "Conversations" */ 'src/components/Dashboard/Views/Conversations/ConversationView.vue'
  );

export const conversationRoutes = [
  {
    path: 'conversations/:conversationId?',
    name: 'Conversations',
    component: ConversationView2,
    props: route => ({
      conversationId: route.params.conversationId ? parseInt(route.params.conversationId) : undefined,
      // Mentioned note timeline id, bigint string. Scrolls the timeline to it
      queryMentionTimeline: route.query.mentionTimeline,
      // followup: route.query.followup === 'true',
      querySort: route.query.sort,
      queryAssignee: route.query.assignee ? parseInt(route.query.assignee) : undefined,
      // queryAgentId: route.query.agentId ? Array.isArray(route.query.agentId) ? route.query.agentId.map(a => parseInt(a)) : [parseInt(route.query.agentId)] : undefined,
      queryDateStart: route.query.dateStart ? new Date(route.query.dateStart) : undefined,
      queryDateEnd: route.query.dateEnd ? new Date(route.query.dateEnd) : undefined,
      // Lead status is either a string if one, or an array if more than one.
      // vue-router is supposed to send an array always but it does not
      queryPriority: route.query.priority ? parseInt(route.query.priority) : undefined,
      queryIncomplete: route.query.incomplete === 'true',
      queryUnassigned: route.query.unassigned === 'true',
      querySnoozed: route.query.snoozed === 'true',
      queryChannels: route.query.channel ? Array.isArray(route.query.channel) ? route.query.channel : undefined : undefined,
      // queryTagIds: route.query.tags ? Array.isArray(route.query.tags) ? route.query.tags.map(t => parseInt(t)) : [parseInt(route.query.tags)] : undefined,
    })
  },
  // Legacy version
  {
    path: 'conversation/',
    name: 'Conversation',
    component: ConversationView,
    props: route => ({
      // followup: route.query.followup === 'true',
      querySort: route.query.sort,
      queryAssignee: route.query.assignee ? parseInt(route.query.assignee) : undefined,
      // queryAgentId: route.query.agentId ? Array.isArray(route.query.agentId) ? route.query.agentId.map(a => parseInt(a)) : [parseInt(route.query.agentId)] : undefined,
      queryDateStart: route.query.dateStart ? new Date(route.query.dateStart) : undefined,
      queryDateEnd: route.query.dateEnd ? new Date(route.query.dateEnd) : undefined,
      // Lead status is either a string if one, or an array if more than one.
      // vue-router is supposed to send an array always but it does not
      queryPriority: route.query.priority ? parseInt(route.query.priority) : undefined,
      queryIncomplete: route.query.incomplete === 'true',
      queryUnassigned: route.query.unassigned === 'true',
      queryChannels: route.query.channel ? Array.isArray(route.query.channel) ? route.query.channel : undefined : undefined,
      // queryTagIds: route.query.tags ? Array.isArray(route.query.tags) ? route.query.tags.map(t => parseInt(t)) : [parseInt(route.query.tags)] : undefined,
    })
  }
];
